var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarSession = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "url(#paint0_linear_54868_146807)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 6.5H12.5V5.5C12.5 5.36739 12.4473 5.24021 12.3536 5.14645C12.2598 5.05268 12.1326 5 12 5C11.8674 5 11.7402 5.05268 11.6464 5.14645C11.5527 5.24021 11.5 5.36739 11.5 5.5V6.5H6.5C6.23478 6.5 5.98043 6.60536 5.79289 6.79289C5.60536 6.98043 5.5 7.23478 5.5 7.5V15C5.5 15.2652 5.60536 15.5196 5.79289 15.7071C5.98043 15.8946 6.23478 16 6.5 16H8.96L7.60938 17.6875C7.52649 17.7911 7.48816 17.9234 7.50282 18.0552C7.51747 18.1871 7.5839 18.3077 7.6875 18.3906C7.7911 18.4735 7.92338 18.5118 8.05524 18.4972C8.1871 18.4825 8.30774 18.4161 8.39062 18.3125L10.24 16H13.76L15.6094 18.3125C15.6504 18.3638 15.7012 18.4065 15.7587 18.4382C15.8162 18.4699 15.8795 18.4899 15.9448 18.4972C16.01 18.5044 16.0761 18.4988 16.1392 18.4805C16.2023 18.4622 16.2612 18.4317 16.3125 18.3906C16.3638 18.3496 16.4065 18.2988 16.4382 18.2413C16.4699 18.1838 16.4899 18.1205 16.4972 18.0552C16.5044 17.99 16.4988 17.9239 16.4805 17.8608C16.4622 17.7977 16.4317 17.7388 16.3906 17.6875L15.04 16H17.5C17.7652 16 18.0196 15.8946 18.2071 15.7071C18.3946 15.5196 18.5 15.2652 18.5 15V7.5C18.5 7.23478 18.3946 6.98043 18.2071 6.79289C18.0196 6.60536 17.7652 6.5 17.5 6.5Z",
  fill: "white"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_54868_146807",
  x1: 6.5,
  y1: 1,
  x2: 16,
  y2: 23,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B6D8B1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D6E28D"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarSession);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_session.b27f7132ebecb072ece1ed25d83fb869.svg";